import { Typography, withStyles } from "@material-ui/core";
export const SnackbarLabel = withStyles({ root: { fontSize: 13 } })(Typography);
